import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/context/LangContext";

const FAQ = () => {
  const { t } = useLang();

  return (
    <section id="faq" className="relative py-32 md:py-40 overflow-hidden">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <div className="text-[11px] tracking-[0.3em] uppercase text-po-accent mb-6">
            {t.faq.eyebrow}
          </div>
          <h2 className="font-display text-white text-4xl sm:text-5xl md:text-6xl tracking-[-0.03em] font-semibold leading-[1.02]">
            {t.faq.title}{" "}
            <span className="font-serif-it text-po-text2">{t.faq.titleItalic}</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-16"
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/[0.07] py-2"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-white hover:no-underline py-6 group">
                  <span className="font-display text-lg md:text-xl font-medium tracking-tight pr-8 group-data-[state=open]:text-po-accent transition-colors">
                    {item.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-po-text2 text-[15px] leading-relaxed pb-6 max-w-3xl">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
